import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { LoaderService } from '../../shared/services/loader.service';
@Component({
  selector: 'app-order-confirmation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-confirmation.component.html',
  styleUrl: './order-confirmation.component.scss',
  animations: [
    trigger('slideInFromTop', [
      state(
        'void',
        style({
          transform: 'translateY(-50px)',
          opacity: 0,
        }),
      ),
      state(
        'visible',
        style({
          transform: 'translateY(0)',
          opacity: 1,
        }),
      ),
      transition('void => visible', [animate('0.8s ease-out')]),
    ]),
    trigger('slideInFromBottom', [
      state(
        'void',
        style({
          transform: 'translateY(50px)',
          opacity: 0,
        }),
      ),
      state(
        'visible',
        style({
          transform: 'translateY(0)',
          opacity: 1,
        }),
      ),
      transition('void => visible', [animate('0.8s ease-out')]),
    ]),
    trigger('fadeIn', [
      state(
        'void',
        style({
          opacity: 0,
        }),
      ),
      state(
        'visible',
        style({
          opacity: 1,
        }),
      ),
      transition('void => visible', [animate('0.6s ease-out')]),
    ]),
  ],
})
export class OrderConfirmationComponent implements OnInit, OnDestroy {
  // Animation states
  confirmationVisible = false;
  addressVisible = false;
  orderSummaryVisible = false;
  buttonsVisible = false;

  // Order data properties
  orderDetail: any = null;
  totalBookingAmount: any;
  orderDetailhistory: any = null;
  orderNumber: string = '';
  deliveryAddress: any = null;
  orderItems: any[] = [];
  totalAmount: number = 0;
  partDetails: any[] = [];
  homeAddress: any[] = [];
  storeAddress: any[] = [];
  // URL parameters
  success: boolean = false;
  orderCancel: boolean = false;
  returOrder: boolean = false;
  orderId: string = '';
  paymentType: string = '';
  userData: any;
  invoiceNumber: any;
  orderStatus: any;
  invoiceLineId: any;
  isEnquiry: boolean = false;
  enquiryNumber: string = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private loaderService: LoaderService,
  ) {}

  ngOnInit() {
    // Scroll to top when page loads
    window.scrollTo(0, 0);

    // Extract URL query parameters
    try {
      const userDataString = localStorage.getItem('userData1');
      if (userDataString) {
        if (userDataString.startsWith('U2FsdGVkX1')) {
          this.userData = {};
        } else {
          this.userData = JSON.parse(userDataString);
        }
      } else {
        this.userData = {};
      }
    } catch (error) {
      console.error('Error parsing userData1 from localStorage:', error);
      this.userData = {};
    }
    this.route.queryParams.subscribe((params) => {
      this.success = params['success'] === 'true';
      this.orderId = params['order_id'] || '';
      this.paymentType = params['payment_type'] || '';
      this.orderCancel = params['orderCancel'] === 'true';
      this.returOrder = params['returOrder'] === 'true';
      this.invoiceNumber = params['invoice_numbers'] || '';
      this.orderStatus = params['status'] || '';
      this.invoiceLineId = params['invoice_line_id'] || '';
      if (!this.orderCancel && !this.returOrder) {
        if (params['is_enquiry'] === 'true') {
          this.isEnquiry = true;
        }
        if (params['enquiry_number']) {
          this.enquiryNumber = params['enquiry_number'];
        }
      } else {
        this.isEnquiry = false;
        this.enquiryNumber = '';
      }
    });

    const state = history?.state;
    if (!this.orderCancel && !this.returOrder) {
      if (state?.isEnquiry || state?.orderDetail?.document_type === 'ENQUIRY') {
        this.isEnquiry = true;
        if (state?.enquiryNumber) {
          this.enquiryNumber = state.enquiryNumber;
        }
      }
    } else {
      this.isEnquiry = false;
      this.enquiryNumber = '';
      localStorage.removeItem('createdOrderDetail');
    }

    if (this.orderCancel) {
      this.orderDetail = null;
      this.getOrderDetail();
    } else if (state?.orderDetail && (!this.returOrder || state?.orderDetail?.order_number === this.orderId)) {
      this.orderDetail = state.orderDetail;
      this.processOrderData();
    } else if (!this.returOrder) {
      const storedDetail = localStorage.getItem('createdOrderDetail');
      if (storedDetail) {
        try {
          const parsed = JSON.parse(storedDetail);
          if (
            (this.isEnquiry && parsed?.document_type === 'ENQUIRY') ||
            (this.orderId && (parsed?.id === this.orderId || parsed?.order_detail?.order_number === this.orderId))
          ) {
            this.orderDetail = parsed;
            this.processOrderData();
          }
        } catch (_) {}
      }
    }

    if (!this.orderCancel && !this.orderDetail && this.orderId) {
      this.getOrderDetail();
    }

    // Trigger animations with delays
    setTimeout(() => {
      this.confirmationVisible = true;
    }, 0);

    setTimeout(() => {
      this.addressVisible = true;
    }, 200);

    setTimeout(() => {
      this.orderSummaryVisible = true;
    }, 400);

    setTimeout(() => {
      this.buttonsVisible = true;
    }, 600);
  }

  ngOnDestroy() {
    localStorage.removeItem('createdOrderDetail');
  }

  private processOrderData() {
    if (this.orderDetail) {
      if (
        !this.orderCancel &&
        !this.returOrder &&
        (this.orderDetail?.document_type === 'ENQUIRY' ||
          (this.orderDetail?.enquiry_numbers &&
            this.orderDetail.enquiry_numbers.length > 0))
      ) {
        this.isEnquiry = true;
        if (!this.enquiryNumber && this.orderDetail.enquiry_numbers?.[0]) {
          this.enquiryNumber = this.orderDetail.enquiry_numbers[0];
        }
      }

      // Extract order number
      this.orderNumber =
        (!this.orderCancel && !this.returOrder ? this.enquiryNumber : '') ||
        this.orderDetail?.order_number ||
        this.orderDetail?.order_detail?.order_number ||
        this.orderDetail?.order_invoice_list?.[0]?.order_number ||
        this.orderDetail?.order_invoice_list?.order_number ||
        this.orderDetail?.order_deatils?.order_number ||
        this.orderDetail?.booking_number ||
        this.orderDetail.id ||
        this.orderId ||
        'N/A';

      // Extract delivery address
      this.deliveryAddress =
        this.orderDetail?.shipping_address ||
        this.orderDetail?.order_deatils?.order_address ||
        this.orderDetail.address ||
        null;

      // Extract order items / part details
      let items =
        this.orderDetail?.line_items ||
        this.orderDetail?.part_details ||
        this.orderDetail?.order_deatils?.order_lines ||
        this.orderDetail?.order_invoice_list?.[0]?.invoice_items ||
        this.orderDetail?.order_items ||
        [];

      // Filter by cancelled / returned items if invoice_line_id is present
      if (
        (this.orderCancel || this.returOrder) &&
        this.invoiceLineId &&
        items.length > 0
      ) {
        const lineIds = Array.isArray(this.invoiceLineId)
          ? this.invoiceLineId.map((id: any) => String(id))
          : String(this.invoiceLineId)
              .split(',')
              .map((id: string) => id.trim());

        const filtered = items.filter((item: any) => {
          const itemId = String(
            item?.invoice_line_id ||
              item?.order_line_id ||
              item?.id ||
              item?.item_id ||
              '',
          );
          return lineIds.includes(itemId);
        });

        if (filtered.length > 0) {
          items = filtered;
        }
      }

      this.partDetails = items;
      if (this.orderDetail?.seller_detail) {
        this.partDetails = this.partDetails.map((item: any) => ({
          ...item,
          seller_detail: item.seller_detail || { ...this.orderDetail.seller_detail },
          seller_name: item.seller_name || this.orderDetail.seller_detail?.seller_name,
        }));
      }
      this.orderItems = this.partDetails;

      // Calculate totalBookingAmount for cancellation / return if not yet set
      if (
        (this.orderCancel || this.returOrder) &&
        (!this.totalBookingAmount || this.totalBookingAmount === 0)
      ) {
        const sum = this.partDetails.reduce(
          (acc: number, item: any) =>
            acc +
            (parseFloat(
              item?.booking_amount ||
                item?.total_amount ||
                item?.item_amount ||
                item?.price ||
                item?.part_rate ||
                0,
            ) || 0),
          0,
        );
        if (sum > 0) {
          this.totalBookingAmount = sum;
        } else if (this.orderDetail?.booking_amount) {
          this.totalBookingAmount =
            parseFloat(this.orderDetail.booking_amount) || 0;
        }
      }

      if (
        this.orderDetail?.shipping_address &&
        (!this.homeAddress || this.homeAddress.length === 0) &&
        (!this.storeAddress || this.storeAddress.length === 0)
      ) {
        const isStore = this.partDetails.some(
          (p: any) => p.delivery_type === 'Store Pickup',
        );
        if (isStore) {
          this.storeAddress = [this.orderDetail.shipping_address];
        } else {
          this.homeAddress = [this.orderDetail.shipping_address];
        }
      }

      // Calculate total amount from part details or order_detail
      if (this.orderDetail?.order_detail?.order_amount !== undefined) {
        this.totalAmount = parseFloat(this.orderDetail.order_detail.order_amount) || 0;
      } else {
        this.totalAmount = this.calculateTotalAmount();
      }
    }
  }

  // Method to get delivery address display text
  getDeliveryAddressText(): string {
    if (!this.deliveryAddress) {
      return 'Address not available';
    }

    const address = this.deliveryAddress;
    const parts = [
      address.street_address || address.address_line1,
      address.city,
      address.state,
      address.pincode || address.postal_code,
    ].filter((part) => part);

    return parts.join(', ');
  }

  // Method to get customer name
  getCustomerName(): string {
    if (!this.deliveryAddress) {
      return 'Customer';
    }
    return (
      this.deliveryAddress.name ||
      this.deliveryAddress.customer_name ||
      'Customer'
    );
  }

  getOrderDetail() {
    this.loaderService.show();

    if (this.orderCancel) {
      this.getBookingDataOnCancel();
      return;
    }

    this.fetchRegularOrderDetail();
  }

  private getBookingDataOnCancel() {
    const payload: any = {
      action_type: 'detail',
    };
    if (this.orderId) {
      payload.order_number = this.orderId;
    }
    if (this.invoiceNumber) {
      payload.booking_number = this.invoiceNumber;
    }

    this.apiService.getBookingData(payload).subscribe({
      next: (res: any) => {
        let detailData: any = res?.data;
        if (
          Array.isArray(detailData?.booking_list) &&
          detailData.booking_list.length > 0
        ) {
          detailData = {
            ...detailData,
            ...detailData.booking_list[0],
            booking_list: detailData.booking_list,
          };
        } else if (Array.isArray(detailData) && detailData.length > 0) {
          detailData = detailData[0];
        }

        if (res?.success && detailData) {
          this.orderDetail = detailData;
          this.orderDetailhistory = detailData;

          const shippingAddress =
            detailData?.shipping_address ||
            detailData?.address ||
            detailData?.order_deatils?.order_address?.find(
              (a: any) => a.order_address_type === 'shipping_address',
            ) ||
            (Array.isArray(detailData?.order_address)
              ? detailData.order_address.find(
                  (a: any) => a.order_address_type === 'shipping_address',
                )
              : null);

          const storeAddress =
            detailData?.store_address ||
            detailData?.seller_detail ||
            detailData?.order_deatils?.order_address?.find(
              (a: any) => a.order_address_type === 'store_address',
            ) ||
            (Array.isArray(detailData?.order_address)
              ? detailData.order_address.find(
                  (a: any) => a.order_address_type === 'store_address',
                )
              : null);

          this.homeAddress = shippingAddress ? [shippingAddress] : [];
          this.storeAddress = storeAddress ? [storeAddress] : [];

          this.processOrderData();
          this.loaderService.hide();
        } else {
          this.fetchRegularOrderDetail();
        }
      },
      error: (err) => {
        console.error('Error fetching booking data on cancel:', err);
        this.fetchRegularOrderDetail();
      },
    });
  }

  private fetchRegularOrderDetail() {
    let payload: {
      order_number: string;
      source?: string;
      invoice_number?: string;
      invoice_status?: string;
      action_type?: string;
      invoice_line_id?: any;
    } = {
      order_number: this.orderId,
    };
    if (this.invoiceNumber) {
      payload.invoice_number = this.invoiceNumber;
      if (this.orderStatus) {
        payload.invoice_status = this.orderStatus;
      }
      payload.action_type = 'invoice_list';
      if (this.invoiceLineId) {
        payload.invoice_line_id = this.invoiceLineId;
      }

      this.apiService.getorderlist(payload).subscribe({
        next: (res) => {
          this.orderDetail = res.data;
          this.orderDetailhistory = res.data;
          if (this.orderDetailhistory?.order_invoice_list) {
            this.orderDetailhistory.order_invoice_list.forEach((invoice: any) => {
              const sellerDetail = invoice.seller_detail;
              this.totalBookingAmount =
                this.orderDetailhistory?.order_invoice_list?.reduce(
                  (sum: number, inv: any) =>
                    sum +
                    (inv.invoice_items?.reduce(
                      (innerSum: number, item: any) =>
                        innerSum + (item.booking_amount || 0),
                      0,
                    ) || 0),
                  0,
                ) || 0;

              // Append seller_detail to each invoice_item
              if (invoice.invoice_items) {
                invoice.invoice_items = invoice.invoice_items.map((item: any) => ({
                  ...item,
                  seller_detail: { ...sellerDetail },
                }));
              }
            });
          }
          const HomeAddress =
            this.orderDetail?.order_invoice_list?.[0]?.order_address?.filter(
              (address: any) =>
                address.order_address_type === 'shipping_address',
            ) || [];
          const storeAddress =
            this.orderDetail?.order_invoice_list?.[0]?.order_address?.filter(
              (address: any) => address.order_address_type === 'store_address',
            ) || [];
          this.homeAddress = HomeAddress;
          this.storeAddress = storeAddress;
          this.processOrderData();
          this.loaderService.hide();
        },
        error: (err) => {
          console.error('Error fetching order detail from getorderlist:', err);
          payload.source = 'db';
          delete payload.invoice_number;
          delete payload.invoice_status;
          delete payload.action_type;
          delete payload.invoice_line_id;
          this.apiService.getOrderDetail(payload).subscribe({
            next: (res) => {
              this.orderDetail = res.data;
              const HomeAddress =
                this.orderDetail?.order_deatils?.order_address?.filter(
                  (address: any) =>
                    address.order_address_type === 'shipping_address',
                ) || [];
              const storeAddress =
                this.orderDetail?.order_deatils?.order_address?.filter(
                  (address: any) => address.order_address_type === 'store_address',
                ) || [];
              this.homeAddress = HomeAddress;
              this.storeAddress = storeAddress;
              this.processOrderData();
              this.loaderService.hide();
            },
            error: (fallbackErr) => {
              console.error('Error fetching order detail from getOrderDetail fallback:', fallbackErr);
              this.loaderService.hide();
            },
          });
        },
      });
    } else {
      payload.source = 'db';
      this.apiService.getOrderDetail(payload).subscribe({
        next: (res) => {
          this.orderDetail = res.data;
          const HomeAddress =
            this.orderDetail?.order_deatils?.order_address?.filter(
              (address: any) =>
                address.order_address_type === 'shipping_address',
            ) || [];
          const storeAddress =
            this.orderDetail?.order_deatils?.order_address?.filter(
              (address: any) => address.order_address_type === 'store_address',
            ) || [];
          this.homeAddress = HomeAddress;
          this.storeAddress = storeAddress;
          this.processOrderData();
          this.loaderService.hide();
        },
        error: (err) => {
          console.error('Error fetching order detail:', err);
          this.loaderService.hide();
        },
      });
    }
  }

  // Method to get contact number
  getContactNumber(): string {
    if (!this.deliveryAddress) {
      return 'N/A';
    }
    return (
      this.deliveryAddress.phone || this.deliveryAddress.contact_number || 'N/A'
    );
  }

  // Method to get GST number
  getGstNumber(): string {
    if (!this.deliveryAddress) {
      return 'N/A';
    }
    return (
      this.deliveryAddress.gst_number || this.deliveryAddress.gstin || 'N/A'
    );
  }

  // Method to get address type
  getAddressType(): string {
    if (!this.deliveryAddress) {
      return 'Home';
    }
    return this.deliveryAddress.address_type || 'Home';
  }

  // Method to calculate total amount from part details
  private calculateTotalAmount(): number {
    if (!this.partDetails || this.partDetails.length === 0) {
      return 0;
    }

    return this.partDetails.reduce((total, part) => {
      const amount = parseFloat(part.total_amount) || 0;
      return total + amount;
    }, 0);
  }

  // Method to get formatted price
  getFormattedPrice(price: string | number): string {
    const numPrice = typeof price === 'string' ? parseFloat(price) : price;
    return `₹${numPrice.toFixed(2)}`;
  }

  // Method to get seller name
  getSellerName(part: any): string {
    const name =
      part?.seller_name ||
      part?.seller_detail?.seller_name ||
      part?.seller_detail?.branch_name ||
      this.orderDetail?.seller_detail?.seller_name ||
      part?.seller_detail?.address_3 ||
      '';
    const city =
      part?.seller_detail?.city ||
      this.orderDetail?.seller_detail?.city ||
      '';
    if (name && city && !name.toLowerCase().includes(city.toLowerCase())) {
      return `${name}, ${city}`;
    }
    return name || city || 'Seller Not Available';
  }

  // Method to get part status
  getPartStatus(part: any): string {
    return part.api_status || 'Pending';
  }

  // Method to continue shopping
  continueShopping() {
    this.router.navigate(['/home']);
  }

  // Method to view order details
  viewOrderDetails() {
    this.gotoProfile();
  }

  gotoList() {
    // localStorage.removeItem('filterState');
    // localStorage.removeItem('category');
    // localStorage.removeItem('seemore');
    // localStorage.removeItem('categoryType');
    // localStorage.removeItem('guideSearchData');
    // localStorage.removeItem('MyGarageData');
    // this.router.navigate(['/product-list']);
    this.router.navigate(['/home']);
  }

  getTotalInvoiceAmount(): number {
    return (
      this.orderDetailhistory?.order_invoice_list?.reduce(
        (sum: number, item: any) => sum + (item.invoice_amount || 0),
        0,
      ) || 0
    );
  }

  gotoProfile() {
    const enquiryNo =
      (!this.orderCancel && !this.returOrder ? this.enquiryNumber : '') ||
      (this.orderDetail?.booking_number && String(this.orderDetail.booking_number).toUpperCase().startsWith('ENQ-') ? this.orderDetail.booking_number : '') ||
      (this.orderDetail?.order_number && String(this.orderDetail.order_number).toUpperCase().startsWith('ENQ-') ? this.orderDetail.order_number : '') ||
      (this.orderDetail?.enquiry_numbers?.[0] || '');

    const isActuallyEnquiry =
      (this.isEnquiry || !!enquiryNo) && !this.orderCancel && !this.returOrder;

    const bookingNumber =
      (isActuallyEnquiry ? enquiryNo : '') ||
      this.orderDetail?.booking_number ||
      this.invoiceNumber ||
      '';

    const orderNumber =
      (isActuallyEnquiry ? enquiryNo : '') ||
      this.orderDetail?.order_number ||
      this.orderId ||
      this.orderDetail?.order_detail?.order_number ||
      this.orderDetail?.order_deatils?.order_number ||
      this.orderDetail?.order_invoice_list?.[0]?.order_number ||
      this.orderDetail?.booking_number ||
      '';

    const orderData: any = {
      order_number: orderNumber,
      booking_number: bookingNumber || (isActuallyEnquiry ? orderNumber : ''),
      document_type: isActuallyEnquiry ? 'ENQUIRY' : (this.orderDetail?.document_type || ''),
      isEnquiry: isActuallyEnquiry,
      invoice_number:
        this.invoiceNumber ||
        this.orderDetail?.booking_number ||
        this.orderDetail?.order_invoice_list?.[0]?.invoice_number ||
        '',
      invoice_status:
        this.orderStatus ||
        this.orderDetail?.booking_status ||
        this.orderDetail?.order_status ||
        this.orderDetail?.order_detail?.status ||
        this.orderDetail?.order_invoice_list?.[0]?.invoice_status ||
        '',
      invoice_items:
        this.orderDetail?.line_items ||
        this.orderDetail?.part_details ||
        this.orderDetail?.order_deatils?.order_lines ||
        this.orderDetail?.order_invoice_list ||
        '',
    };

    if (orderData.order_number || orderData.booking_number) {
      const targetBookingNumber =
        orderData.booking_number || (isActuallyEnquiry ? orderData.order_number : '');

      this.router.navigate(['/orders-details'], {
        queryParams: isActuallyEnquiry && targetBookingNumber
          ? { booking_number: targetBookingNumber, is_enquiry: 'true' }
          : undefined,
        state: {
          orderData,
          fromOrderConfirmation: true,
          isEnquiry: isActuallyEnquiry,
          isBookingFlow: isActuallyEnquiry,
        },
      });
      return;
    }

    this.router.navigate(['/user-profile'], { queryParams: { section: 'orders' } });
  }
}
